module.exports = __webpack_public_path__ + "img/settings-icon-active.df0efc6e.svg";